import { FC, memo } from 'react';
import cn from 'bem-cn';
import { usePromptFeedColumns } from '../HomePage/HomePage.hooks';
import { Feed, useInfiniteFeed } from '../../components/Feed';
import { HeaderLogo } from '../../components/Header/HeaderLogo';
import './PromoResearchPage.scss';

const b = cn('promo-research-page');

export const PromoResearchPage: FC = memo(() => {
    const columns = usePromptFeedColumns(true);
    // const { selectedCategories, updateSelectedCategories } = useSelectedCategories();

    const { prompts, loading: isLoading, hasMore } = useInfiniteFeed({ threshold: 600, category: 'research' });

    return (
        <div className={b()}>
            <div className={b('header')}>
                <HeaderLogo className={b('logo')} />
                <div className={b('header-textdescription')}>
                    <h1 className={b('title')}>
                        Агент &laquo;Исследовать&raquo;
                        <br />
                        у&nbsp;Алисы AI
                    </h1>
                    <p className={b('description')}>
                        Агент &laquo;Исследовать&raquo; изучит сотни источников и&nbsp;подготовит структурированный
                        отчёт с&nbsp;фактами и&nbsp;расчётами&nbsp;&mdash; за&nbsp;минуты, не&nbsp;часы.
                    </p>
                </div>
            </div>
            <div className={b('content')}>
                <h3 className={b('feed-title')}>Примеры задач &mdash; попробуйте прямо сейчас</h3>
                <Feed
                    containerClassName={b('feed')}
                    prompts={prompts}
                    courses={[]}
                    challenges={[]}
                    columns={columns}
                    isLoading={isLoading}
                    hasMore={hasMore}
                    needMarkPromptsAsViewed
                    isHomePage
                    cardClickOpenAliceChat
                />
            </div>
        </div>
    );
});
